import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { IMAGES } from "../data/content";

export const PageHeader = ({ title, subtitle }) => (
  <section className="relative bg-hecso-greendark" data-testid="page-header">
    <div className="absolute inset-0">
      <img src={IMAGES.teaGarden} alt="" className="w-full h-full object-cover opacity-20" />
    </div>
    <div className="relative container-hecso py-14 sm:py-20">
      <nav className="flex items-center gap-1 text-xs text-white/70 mb-3" data-testid="breadcrumb">
        <Link to="/" className="hover:text-white transition-colors">Home</Link>
        <ChevronRight className="w-3 h-3" />
        <span className="text-white">{title}</span>
      </nav>
      <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">{title}</h1>
      {subtitle && <p className="mt-3 max-w-2xl text-sm sm:text-base text-white/80 leading-relaxed">{subtitle}</p>}
    </div>
  </section>
);
